import { render, staticRenderFns } from "./QuestionParagraph.vue?vue&type=template&id=4705a95e&scoped=true&"
import script from "./QuestionParagraph.vue?vue&type=script&lang=js&"
export * from "./QuestionParagraph.vue?vue&type=script&lang=js&"
import style0 from "./QuestionParagraph.vue?vue&type=style&index=0&id=4705a95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705a95e",
  null
  
)

export default component.exports